import api from "./api";

export async function getEnergyMeterLastRecord(usinaId) {
    const res = await api.get(`energia_medidor/usina/${usinaId}/lastRecord`);
    return res.data;
}
